/* eslint-disable */
(function ($) {
    const App = {
      rcecMobMenu() {
        console.log("Loading Mob Menu");
        $("#mobile-bars").sidr({
          name: "sidr",
          side: "left",
          speed: 400,
          displace: false,
          timing: "ease",
          onOpen() {
            $("#mobile-bars i").removeClass("fa-bars").addClass("fa-times");
            $("body").css({
              position: "fixed",
              width: "100%",
              background: "rgba(0, 0, 0, 0.5)",
            });
            $("#sidr").css("display", "block");
          },
          onClose() {
            $("#mobile-bars i").removeClass("fa-times").addClass("fa-bars");
            $("body").css({
              position: "static",
              width: "auto",
              background: "transparent",
            });
          },
        });
        $("#sidr").css("display", "block");
        $(document).on("click", function (e) {
          if (!$(e.target).closest("#sidr").length) {
            $.sidr("close", "sidr");
          }
        });
  
        /*sidr sub menu*/
        const sidrParentMenu = $("#sidr #mobile-view li.menu-item-has-children");
        const sidrSubmenu = $("#sidr #mobile-view ul.sub-menu");
        const parentAncor = $(
          "#sidr #mobile-view li.menu-item-has-children"
        ).children("a");
  
        $('<i class="fa-solid fa-chevron-down"></i>').appendTo(parentAncor);
        sidrSubmenu.hide();
        sidrParentMenu.children("a").on("click", function (e) {
          e.preventDefault();
          $(this).next("ul.sub-menu").stop().slideToggle();
          $(this).children("i").toggleClass("fa-chevron-down fa-chevron-up");
        });
        $("ul#mobile-view li.menu-item-has-children a").css({
          display: "flex",
          "justify-content": "space-between",
          "align-items": "center",
        });
      },
      rcecVenobox() {
        let venoBox = new VenoBox({
            selector: ".image-popup",
            bgcolor: "#3C92CA",
            numeration: true,
            spinner: "wandering-cubes",
          });
      },
      rcecSlider(){
        var swiper = new Swiper(".rcecSlider", {
          spaceBetween: 30,
          loop: true,
          // autoplay: {
          //   delay: 3500,
          //   disableOnInteraction: false,
          // }
        });
      },
      rcecMemberCarousel(){
        let membersSlider = new Swiper(".rcecMembers", {
            slidesPerView: 1,
            spaceBetween: 30,
            loop: true,
            autoplay: {
              delay: 2500,
              disableOnInteraction: false,
            },
            // pagination: {
            //   el: ".member-pagination",
            //   clickable: true,
            // },
            breakpoints: {
                640: {
                  slidesPerView: 2,
                  spaceBetween: 20,
                },
                768: {
                  slidesPerView: 4,
                  spaceBetween: 40,
                },
                1024: {
                  slidesPerView: 5,
                  spaceBetween: 50,
                },
              },
          });
      },
      rcecCounterUp() {
        $(".counter").counterUp({
          delay: 10,
          time: 1000,
        }); //lightbox
      }
    };
  
    App.init = function () {
      App.rcecMobMenu();
      App.rcecVenobox();
      App.rcecSlider();
      App.rcecMemberCarousel();
      App.rcecCounterUp();
    };
    $(function () {
        App.init();
    });
  })(jQuery);
  